<div class="loading-bay" :class="{ loading: loading, failed: failed }"><div ref="content"></div></div>